import { motion } from "framer-motion";

export default function MusicPlayer() {
  return (
    <section
      id="music"
      data-testid="music-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-tighter mb-2"
            data-testid="music-section-title"
          >
            Słuchaj
          </h2>
          <div className="w-16 h-[2px] bg-[#EB0023] mb-10" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="spotify-container bg-[#192D48]/30 backdrop-blur-md border border-[#32558B]/20 p-4 md:p-6"
        >
          <iframe
            data-testid="spotify-embed"
            title="Pueblo on Spotify"
            src="https://open.spotify.com/embed/artist/2qEWBu2U2c5bzsnSrfpBY4?utm_source=generator&theme=0"
            width="100%"
            height="352"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            style={{ borderRadius: 0, border: 'none' }}
          />
          <div className="mt-4 text-center">
            <a
              href="https://open.spotify.com/artist/2qEWBu2U2c5bzsnSrfpBY4"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="spotify-direct-link"
              className="inline-flex items-center gap-2 text-[#A0B0C4] hover:text-white font-['Manrope'] text-sm transition-colors"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>
              Otwórz w Spotify
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
